<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      clipped
      left
      permanent
      expand-on-hover
      app
      v-if="verificationStatus != 3 && display != 2"
    >
      <v-list
        shaped
        dense
        rounded
        class="ml-n2"
        :disabled="$store.getters.get_getCustDetails.is_purchase == 0"
      >
        <v-list-item
          to="/Dashboard"
          class="primary--text"
          active-class="border"
          :value="false"
          no-action
        >
          <v-list-item-icon>
            <v-icon
              :color="
                $store.getters.get_getCustDetails.is_purchase == 0
                  ? 'grey'
                  : 'primary'
              "
              style="font-size: 17px"
              >mdi mdi-desktop-mac-dashboard</v-icon
            >
          </v-list-item-icon>
          <v-list-item-title
            class="ml-n5"
            :class="
              $store.getters.get_getCustDetails.is_purchase == 0
                ? 'grey--text'
                : 'primary--text'
            "
            >Dashboard</v-list-item-title
          >
        </v-list-item>
        <v-list-group dark :value="false" :no-action="!isMobile">
          <template v-slot:activator>
            <v-list-item-content class="listItem pa-0 primary--text">
              <v-list-item-icon>
                <v-icon
                  class="ml-0"
                  style="font-size: 17px"
                  :color="
                    $store.getters.get_getCustDetails.is_purchase == 0
                      ? 'grey'
                      : 'primary'
                  "
                  >mdi-card-plus</v-icon
                >

                <v-list-item-title
                  class="ml-5"
                  :class="
                    $store.getters.get_getCustDetails.is_purchase == 0
                      ? 'grey--text'
                      : 'primary--text'
                  "
                  >Cards<v-badge
                    v-if="
                      cardcount != null && cardcount != '0' && cardcount != ''
                    "
                    :content="cardcount"
                    value="cardcount"
                    color="primary "
                    class="ml-3 mb-1"
                  >
                  </v-badge
                ></v-list-item-title>
              </v-list-item-icon>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="(setting, i) in itemsettings"
            :key="i"
            link
            :disabled="expandcheck"
            :to="setting[2]"
            active-class="border"
          >
            <v-list-item-title
              v-text="setting[0]"
              class="primary--text"
              :class="
                $store.getters.get_getCustDetails.is_purchase == 0
                  ? 'grey--text'
                  : 'primary--text'
              "
            ></v-list-item-title>

            <v-badge
              v-if="
                cardcount != null &&
                cardcount != '0' &&
                cardcount != '' &&
                setting[3] == '1'
              "
              :content="cardcount"
              value="cardcount"
              color="primary "
              class="mr-10 mt-2"
            >
            </v-badge>
          </v-list-item>
        </v-list-group>
        <v-list-item
          color="primary"
          v-for="(item, i) in users"
          :key="i"
          :to="item.link"
          active-class="border"
        >
          <v-list-item-content class="primary--text">
            <v-list-item-title
              v-text="item.text"
              :class="
                $store.getters.get_getCustDetails.is_purchase == 0
                  ? 'grey--text'
                  : 'primary--text'
              "
            ></v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-group :value="false" :no-action="!isMobile" color="primary">
          <template v-slot:activator>
            <v-list-item-content class="listItem pa-0 primary--text">
              <v-list-item-icon>
                <v-icon
                  :color="
                    $store.getters.get_getCustDetails.is_purchase == 0
                      ? 'grey'
                      : 'primary'
                  "
                  class="ml-0"
                  style="font-size: 17px"
                  >mdi-cash-multiple</v-icon
                >

                <v-list-item-title
                  class="ml-5"
                  :class="
                    $store.getters.get_getCustDetails.is_purchase == 0
                      ? 'grey--text'
                      : 'primary--text'
                  "
                  >Corporate Funds</v-list-item-title
                >
              </v-list-item-icon>
            </v-list-item-content>
          </template>
          <v-list-item
            v-for="(setting, i) in corpfundsm"
            :key="i"
            link
            :disabled="expandcheck"
            :to="setting[2]"
            active-class="border"
            @click="setfalsedialog(setting)"
          >
            <v-list-item-title
              @click="setfalsedialog"
              v-text="setting[0]"
              class="primary--text"
              :class="
                $store.getters.get_getCustDetails.is_purchase == 0
                  ? 'grey--text'
                  : 'primary--text'
              "
            ></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group :value="false" :no-action="!isMobile" color="primary">
          <template v-slot:activator>
            <v-list-item-content class="listItem pa-0 primary--text">
              <v-list-item-icon>
                <v-icon
                  :color="
                    $store.getters.get_getCustDetails.is_purchase == 0
                      ? 'grey'
                      : 'primary'
                  "
                  class="ml-0"
                  style="font-size: 17px"
                  >mdi-cash-usd</v-icon
                >

                <v-list-item-title
                  class="ml-5"
                  :class="
                    $store.getters.get_getCustDetails.is_purchase == 0
                      ? 'grey--text'
                      : 'primary--text'
                  "
                  >Card Funds<v-badge
                    v-if="fundcount != null && fundcount != '0'"
                    :content="fundcount"
                    value="fundcount"
                    color="primary "
                    class="ml-3 mb-1"
                  >
                  </v-badge
                ></v-list-item-title>
                <!-- <v-badge
              v-if="fundcount != null && fundcount != '0' && setting[3] == '1' "
             color="gold"
          class="mt-2"
          dot
            >
            </v-badge> -->
              </v-list-item-icon>
            </v-list-item-content>
          </template>
          <v-list-item
            v-for="(setting, i) in cardfundsm"
            :key="i"
            :disabled="expandcheck"
            link
            :to="setting[2]"
            active-class="border"
          >
            <v-list-item-title
              v-text="setting[0]"
              class="primary--text"
              :class="
                $store.getters.get_getCustDetails.is_purchase == 0
                  ? 'grey--text'
                  : 'primary--text'
              "
            >
            </v-list-item-title>

            <v-badge
              v-if="fundcount != null && fundcount != '0' && setting[3] == '1'"
              :content="fundcount"
              value="fundcount"
              color="primary "
              class="mr-8 mt-2"
            >
            </v-badge>
          </v-list-item>
        </v-list-group>

        <div>
          <v-list-item
            v-for="(setting, i) in users2"
            :key="i"
            @click="setfalsedialog"
            link
            :to="setting[2]"
          >
            <v-list-item-icon>
              <v-icon
                :color="
                  $store.getters.get_getCustDetails.is_purchase == 0
                    ? 'grey'
                    : 'primary'
                "
                class="ml-0"
                v-text="setting[1]"
                style="font-size: 17px"
              >
              </v-icon>
              <v-badge
                color="gold"
                class="mt-2"
                dot
                v-if="
                  expensecount1 != null &&
                  expensecount1 != '0' &&
                  setting[3] == '1'
                "
              >
              </v-badge>
              <v-badge
                color="gold"
                class="mt-2"
                dot
                v-if="
                  expensecount2 != null &&
                  expensecount2 != '0' &&
                  setting[3] == '1'
                "
              >
              </v-badge>
              <v-badge
                v-if="
                  expenserecovercount != null &&
                  expenserecovercount != '0' &&
                  setting[3] == '0'
                "
                color="gold"
                class="mt-2"
                dot
              >
              </v-badge>
            </v-list-item-icon>
            <v-list-item-title
              :class="
                $store.getters.get_getCustDetails.is_purchase == 0
                  ? 'grey--text'
                  : 'primary--text ml-n5'
              "
              @click="setfalsedialog"
              v-text="setting[0]"
            ></v-list-item-title>
            <v-badge
              v-if="
                expensecount3 != null &&
                expensecount3 != '0' &&
                setting[3] == '1'
              "
              :content="expensecount3"
              value="expensecount3"
              color="primary "
              class="mr-8 mt-3"
            >
            </v-badge>
            <!-- <v-badge
              v-if="expensecount2 != null && expensecount2 != '0'  && setting[3] == '1'"
              :content="expensecount2 "
              value="expensecount2"
              color="primary "
              class="mr-5 mt-3"
            >
            </v-badge> -->

            <v-badge
              v-if="
                expenserecovercount != null &&
                expenserecovercount != '0' &&
                setting[3] == '0'
              "
              :content="expenserecovercount"
              value="expenserecovercount"
              color="primary "
              class="mr-8 mt-3"
            >
            </v-badge>
          </v-list-item>
        </div>
        <v-list-group :value="false" :no-action="!isMobile" color="primary">
          <template v-slot:activator>
            <v-list-item-content class="listItem pa-0 primary--text">
              <v-list-item-icon>
                <v-icon
                  :color="
                    $store.getters.get_getCustDetails.is_purchase == 0
                      ? 'grey'
                      : 'primary'
                  "
                  class="ml-0"
                  style="font-size: 17px"
                  >mdi-card-account-details</v-icon
                >

                <v-list-item-title
                  class="ml-5"
                  :class="
                    $store.getters.get_getCustDetails.is_purchase == 0
                      ? 'grey--text'
                      : 'primary--text'
                  "
                  >Card Users</v-list-item-title
                >
                <!-- <v-badge
              v-if="fundcount != null && fundcount != '0' && setting[3] == '1' "
             color="gold"
          class="mt-2"
          dot
            >
            </v-badge> -->
              </v-list-item-icon>
            </v-list-item-content>
          </template>
          <v-list-item
            v-for="(setting, i) in cardUsers"
            :key="i"
            :disabled="expandcheck"
            link
            :to="setting[2]"
            active-class="border"
          >
            <v-list-item-title
              v-text="setting[0]"
              class="primary--text"
              :class="
                $store.getters.get_getCustDetails.is_purchase == 0
                  ? 'grey--text'
                  : 'primary--text'
              "
            >
            </v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-item
          to="/Transactions"
          class="primary--text"
          active-class="border"
          :value="false"
          no-action
        >
          <!-- <v-list-item-content
            class="listItem pa-0 primary--text"
          
          > -->
          <v-list-item-icon>
            <v-icon
              :color="
                $store.getters.get_getCustDetails.is_purchase == 0
                  ? 'grey'
                  : 'primary'
              "
              style="font-size: 17px"
              >mdi-receipt</v-icon
            >
          </v-list-item-icon>
          <v-list-item-title
            :class="
              $store.getters.get_getCustDetails.is_purchase == 0
                ? 'grey--text'
                : 'primary--text ml-n5'
            "
            >Card Transactions</v-list-item-title
          >
          <!-- </v-list-item-content> -->
        </v-list-item>

        <v-list-group
          prepend-icon=""
          :value="$store.getters.get_Department"
          :no-action="!isMobile"
          color="primary"
        >
          <template v-slot:activator>
            <v-list-item-content class="listItem pa-0 primary--text">
              <v-list-item-icon>
                <v-icon
                  :color="
                    $store.getters.get_getCustDetails.is_purchase == 0
                      ? 'grey'
                      : 'primary'
                  "
                  class="ml-0"
                  style="font-size: 17px"
                  >mdi-vanish</v-icon
                >

                <v-list-item-title
                  class="ml-5"
                  :class="
                    $store.getters.get_getCustDetails.is_purchase == 0
                      ? 'grey--text'
                      : 'primary--text'
                  "
                  >Settings</v-list-item-title
                >
              </v-list-item-icon>
            </v-list-item-content>
          </template>
          <v-list-item
            v-for="(setting, i) in Master"
            :key="i"
            link
            :disabled="expandcheck"
            :to="setting[2]"
            active-class="border"
            @click="setfalsedialog"
          >
            <v-list-item-title
              @click="setfalsedialog"
              v-text="setting[0]"
              class="primary--text"
              :class="
                $store.getters.get_getCustDetails.is_purchase == 0
                  ? 'grey--text'
                  : 'primary--text'
              "
            ></v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>
      <!-- <template v-slot:append>
      <span class="caption ml-3 mt-n2 primary--text"
          
          ><b>V-1.6</b></span
        >
        </template> -->
       
      <v-dialog
        v-model="profileDialog"
        width="400"
        persistent
        transition="dialog-bottom-transition"
      >
        <v-card class="overflow-hidden">
          <v-toolbar flat color="primary" dark>
            <v-toolbar-title>Profile</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text class="pt-5">
            <v-row>
              <v-icon color="gold">mdi-account</v-icon>

              <v-col class="pl-5">
                <span class="caption">NAME</span>
                <br />
                <span class="subtitle-1 black--text">
                  {{ (accounDetails.user_name || "").toUpperCase() }}
                </span>
              </v-col>
            </v-row>
            <v-row>
              <v-icon color="gold">mdi-email</v-icon>
              <v-col class="pl-5">
                <span class="caption">EMAIL</span>
                <br />
                <span class="subtitle-1 black--text">
                  {{ accounDetails.email }}
                </span>
              </v-col>
            </v-row>
            <v-row>
              <v-icon color="gold">mdi-phone</v-icon>
              <v-col class="pl-5">
                <span class="caption">MOBILE</span>
                <br />
                <span class="subtitle-1 black--text">
                  {{ accounDetails.mobile_num }}
                </span>
              </v-col>
            </v-row>

            <v-row>
              <v-icon color="gold">mdi-calendar-range</v-icon>
              <v-col class="pl-5">
                <span class="caption">DATE OF ONBOARDING</span>
                <br />
                <span class="subtitle-1 black--text">
                  {{ accounDetails.date_of_onboard }}
                </span>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="red" @click="profileDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="helpDeskStatus"
        width="400"
        persistent
        transition="dialog-bottom-transition"
      >
        <v-card class="overflow-hidden">
          <v-toolbar flat color="primary" dark dense>
            <v-toolbar-title class="subtitle-2"
              >Please Fill All Master Field</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-btn class text dark @click="helpDeskStatus = false">
              <v-icon color="white" class="subtitle-2">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="pt-5">
            <v-row>
              <v-col cols="12">
                <span>
                  <div class="blue--text" @click="pushToDept('Department')">
                    Department Master
                  </div>
                </span>
              </v-col>
              <v-col cols="12">
                <span>
                  <div class="blue--text" @click="pushToDept('Expense')">
                    Expense Rule
                  </div>
                </span>
              </v-col>
              <v-col cols="12">
                <span>
                  <div class="blue--text" @click="pushToDept('Category')">
                    Expense Category
                  </div>
                </span>
              </v-col>
              <v-col cols="12">
                <span>
                  <div class="blue--text" @click="pushToDept('Card')">
                    Card Type Master
                  </div>
                </span>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-navigation-drawer>

    <v-navigation-drawer
      v-model="drawer"
      clipped
      left
      permanent
      expand-on-hover
      app
      v-else
    >
      <v-list shaped dense rounded class="ml-n2">
        <v-list-item
          to="/ReferrerDashboard"
          class="primary--text"
          active-class="border"
          :value="false"
          no-action
        >
          <v-list-item-icon>
            <v-icon
              color="
               
                primary"
              style="font-size: 17px"
              >mdi mdi-desktop-mac-dashboard</v-icon
            >
          </v-list-item-icon>
          <v-list-item-title
            class="ml-n5"
            color="
               
               primary"
            >DashBoard</v-list-item-title
          >
        </v-list-item>
        <v-list-item
          to="/ViewCorp"
          class="primary--text"
          active-class="border"
          :value="false"
          no-action
        >
          <v-list-item-icon>
            <v-icon
              color="
               
                primary"
              style="font-size: 17px"
              >mdi mdi-view-carousel-outline</v-icon
            >
          </v-list-item-icon>
          <v-list-item-title
            class="ml-n5"
            color="
               
               primary"
            >View Corporate</v-list-item-title
          >
        </v-list-item>
        <v-list-item
          to="/CreateCorp"
          class="primary--text"
          active-class="border"
          :value="false"
          no-action
        >
          <v-list-item-icon>
            <v-icon
              color="
               
                primary"
              style="font-size: 17px"
            >
              mdi-office-building-marker-outline</v-icon
            >
          </v-list-item-icon>
          <v-list-item-title
            class="ml-n5"
            color="
               
               primary"
            >Refer Corporate</v-list-item-title
          >
        </v-list-item>
        <v-list-item
          to="/RefCommission"
          class="primary--text"
          active-class="border"
          :value="false"
          no-action
        >
          <v-list-item-icon>
            <v-icon
              color="
               
                primary"
              style="font-size: 17px"
            >
              mdi-sack-percent</v-icon
            >
          </v-list-item-icon>
          <v-list-item-title
            class="ml-n5"
            color="
               
               primary"
            >Referrer Commission</v-list-item-title
          >
        </v-list-item>
      </v-list>
     
       
      <v-dialog
        v-model="profileDialog1"
        width="400"
        persistent
        transition="dialog-bottom-transition"
      >
        <v-card class="overflow-hidden">
          <v-toolbar flat color="primary" dark>
            <v-toolbar-title>Profile</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text class="pt-5">
            <v-row>
              <v-icon color="gold">mdi-account</v-icon>

              <v-col class="pl-5">
                <span class="caption">NAME</span>
                <br />
                <span class="subtitle-1 black--text">
                  {{ (accounDetailsref.referrer_name || "").toUpperCase() }}
                </span>
              </v-col>
            </v-row>
            <v-row>
              <v-icon color="gold">mdi-email</v-icon>
              <v-col class="pl-5">
                <span class="caption">EMAIL</span>
                <br />
                <span class="subtitle-1 black--text">
                  {{ accounDetailsref.email_id }}
                </span>
              </v-col>
            </v-row>
            <v-row>
              <v-icon color="gold">mdi-phone</v-icon>
              <v-col class="pl-5">
                <span class="caption">MOBILE</span>
                <br />
                <span class="subtitle-1 black--text">
                  {{ accounDetailsref.mobile_no }}
                </span>
              </v-col>
            </v-row>

            <v-row>
              <v-icon color="gold">mdi-calendar-range</v-icon>
              <v-col class="pl-5">
                <span class="caption">DATE OF ONBOARDING</span>
                <br />
                <span class="subtitle-1 black--text">
                  {{ accounDetailsref.created_on }}
                </span>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="red" @click="profileDialog1 = false"
              >Close</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-navigation-drawer>

    <v-app-bar color="primary" app clipped-left v-if="!isMobile">
      <img
        v-if="!$vuetify.theme.dark"
        src="@/assets/logo7.png"
        width="100px "
        class="mt-n3 ml-n1"
      />
      <div class="body-1 mt-1 white--text ml-8" v-if="display != 2">
        Hi, {{ accounDetails.user_name }}
      </div>
      <div class="body-1 mt-1 white--text ml-8" v-if="display == 2">
        Hi, {{ accounDetailsref.referrer_name }}
      </div>

      <v-spacer></v-spacer>

      <span class="mr-2 mt-n1 body-2 white--text">
        <v-icon small class="white--text">mdi-email</v-icon> admin@glyd.com.my
        <v-icon small class="ml-2 white--text"> mdi-phone</v-icon> +60 3 2786
        5380
      </span>
      <div class="body-1 mx-4 mt-n1 white--text" v-if="display != 2">
        {{ $store.getters.get_getCustDetails.corp_name }}
      </div>
      <div class="body-1 mx-4 mt-n1 white--text" v-if="display == 2">
        {{ $store.getters.get_getRefDetails.comp_name }}
      </div>
      <v-menu offset-y v-if="display != 2">
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="primary" dark depressed v-bind="attrs" v-on="on">
            <v-icon>mdi-account-details</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <v-btn
              class="ma-0"
              color="primary"
              text
              @click="profileDialog = true"
            >
              <v-icon medium class="mr-1">mdi-account-circle-outline </v-icon>
              {{ (accounDetails.user_name || "").toUpperCase() }}
            </v-btn>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-btn class="ma-0" color="red" text @click="signOut">
              <v-icon medium class="mr-1">mdi-logout</v-icon>Sign Out
            </v-btn>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu offset-y v-if="display == 2">
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="primary" dark depressed v-bind="attrs" v-on="on">
            <v-icon>mdi-account-details</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <v-btn
              class="ma-0"
              color="primary"
              text
              @click="profileDialog1open()"
            >
              <v-icon medium class="mr-1">mdi-account-circle-outline </v-icon>
              {{ (accounDetailsref.referrer_name || "").toUpperCase() }}
            </v-btn>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-btn class="ma-0" color="red" text @click="signOut">
              <v-icon medium class="mr-1">mdi-logout</v-icon>Sign Out
            </v-btn>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-app-bar color="primary" app clipped-left v-if="isMobile">
      <img
        v-if="!$vuetify.theme.dark"
        src="@/assets/logo7.png"
        width="100px "
        class="mt-n3 ml-n1"
      />
      <v-spacer />
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="primary" dark depressed v-bind="attrs" v-on="on">
            <v-icon>mdi-account-details</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <v-btn
              class="ma-0"
              color="primary"
              text
              @click="profileDialog = true"
            >
              <v-icon medium class="mr-1">mdi-account-circle-outline </v-icon>
              {{ (accounDetails.user_name || "").toUpperCase() }}
            </v-btn>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-btn class="ma-0" color="red" text @click="signOut">
              <v-icon medium class="mr-1">mdi-logout</v-icon>Sign Out
            </v-btn>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
  

  </div>
</template>

<script>
import { apiCall } from "@/Views/APICALL/APIcall.js";

export default {
  components: {},
  name: "Navbar",

  props: {
    source: String,
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    accounDetails() {
      return this.$store.getters.get_getCustDetails;
    },
    accounDetailsref() {
      return this.$store.getters.get_getRefDetails;
    },

    verificationStatus() {
      return this.$store.getters.get_VerificatnStatus;
    },
    display() {
      return this.$store.getters.get_display;
    },

    auth() {
      return this.$store.getters.get_auth;
    },
    // fundcount() {
    //   return this.$store.getters.get_FundCount;
    // },
    expensecount1() {
      return this.$store.getters.get_ExpenseCount1;
    },
    expensecount2() {
      return this.$store.getters.get_ExpenseCount2;
    },
    expenserecovercount() {
      return this.$store.getters.get_ExpenseRecoverCount;
    },
    // cardcount() {
    //   return this.$store.getters.get_Requestcards;
    // },
    expensecount3() {
      var expensecount3;

      expensecount3 =
        Number(this.$store.getters.get_ExpenseCount1) +
        Number(this.$store.getters.get_ExpenseCount2);
      return expensecount3;
    },
    fundcount: {
      get() {
        return this.$store.getters.get_FundCount;
      },
      set(value) {
        this.$store.commit("SET_FundCount", value);
      },
    },
    cardcount: {
      get() {
        return this.$store.getters.get_Requestcards;
      },
      set(value) {
        this.$store.commit("SET_Requestcards", value);
      },
    },


  },
  data: () => ({
    helpDeskStatus: false,
    profileDialog: false,
    item: "",
    drawer: null,
    ContactNumber: "",
    search: "",
    show: false,
    icondialog: false,
    Address: "",
    // cardcount: "",
    EditDetailsDialog: false,
    links: [{ route: "/Navbar" }],
    panel: 1,
    border: 1,
    expandcheck: false,
    profileDialog1: false,
    itemsettings: [
      ["Request Cards", "mdi-cart-plus", "/RequestCard", "1"],
      // ["Status", "mdi-credit-card-scan", "/CardStatus"],
      ["Card Stock Mgmt", "mdi-account-multiple", "/cardstockmanagement", ""],
      ["Subscription", "mdi-cart-plus", "/Subscription", ""],
    ],
    users: [],
    InvoiceList: [
      ["Vendor", "mdi-account-multiple", "/Createvendor"],
      [
        "Expense Classification",
        "mdi-account-multiple",
        "/InvoiceExpenseClassificatn",
      ],
      ["Invoice Upload", "mdi-account-multiple", "/UploadInvoice"],
      ["Invoice Payment", "mdi-account-multiple", "/Invoicepayment"],
      ["Approval", "mdi-account-multiple", "/ApprovalInvoice"],
    ],

    users2: [
      // { text: "User Mgmt", icon: "mdi-account-multiple", link: "/users" },
      // {
      //   text: "Corporate Funds",
      //   icon: "mdi-cash-multiple",
      //   link: "/corporatefunds",
      // },
      ["Expense Approval", "mdi-check-circle", "/ApprovalExpense", "1", "6"],

      ["Expense Recovery", "mdi-restore", "/Recoverytab", "0"],
      // ["Card Users", "mdi-account-multiple", "/Employees", "5"],
      ["Admin Access", "mdi-account-plus", "/AdminAccess", "2"],
      ["Budget", "mdi-currency-btc", "/Budget", "3"],
      // ["Billing Report", "mdi-chart-histogram", "/billingreport","4"],
    ],
    cardUsers: [
      ["Card Users", "mdi-account-multiple", "/Employees", "5"],
      ["Approval", "mdi-account-multiple", "/AppTrail", "5"],
    ],
    expenseManagement: [
      // ["Masters", "mdi-map-marker-plus", "/ExpenseRuleMasters"],
      // ["User Type ", "mdi-share", "ExpenseMgmtUserTypeCreation"],
      // ["Rules", "mdi-share", "ExpenseMgmtrules"],
      ["Approval", "mdi-map-marker-plus", "/ExpenseMgmtApprovalExpense"],
      // ["Recovery", "mdi-map-marker-plus", "/ExpenseMgmtPartialApprove"],
    ],
    cardfundsm: [
      ["Load Cards", "mdi-share", "CardBalance", "0"],
      ["Unload Cards", "mdi-share", "Unload", "2"],
      ["Approval", "mdi-share", "/FundApproval", "1"],
    ],
    corpfundsm: [
      ["Fund Account", "mdi-cash-100", "corporatefundrequest"],
      ["Transactions", "mdi-share", "corporatetransaction"],
    ],

    funds: [
      // ["Upload", "mdi-upload", "/upload"],

      ["Corporate Funds", "mdi-cash-100", "/corporatefunds"],
      ["Card Funds", "mdi-cash-multiple", "/cardfunds"],
    ],

    Master: [
      // ["Card Type Masters", "mdi-map-marker-plus", "/CardTypeMaster"],

      ["Department Masters", "mdi-group", "/DepartmentMasters"],
      // ["Budget Duration", "mdi-timer-sand", "/BudgetDuration"],
      // ["Location List", "mdi-map-marker-plus", "/location"],

      ["Expense Category", "mdi-map-marker-plus", "/ExpenseCategory"],
      // ["Card Funds", "mdi-cash-multiple", "/cardfunds"],
      ["Expense Masters", "mdi-map-marker-plus", "/ExpenseRuleMasters"],
      ["Expense User Type ", "mdi-share", "ExpenseMgmtUserTypeCreation"],
      ["Expense Rules", "mdi-share", "ExpenseMgmtrules"],
    ],
    itemsO: [
      {
        text: "Dashboard",
        icon: "mdi mdi-desktop-mac-dashboard",
        link: "/Dashboard",
      },

      // {
      //   text: "Request Card",
      //   icon: "mdi-cart-plus",
      //   link: "/RequestCard",
      // },
    ],
  }),
  // created() {
  //   if (this.auth == false) {
  //     this.$router.push("/");
  //   } else {
  //     this.$store.commit("SET_VerificatnStatus", 1);

  //     if (this.verificationStatus == 3) {
  //       this.drawer = false;
  //     }
  //   }

  // },
  mounted() {
    this.getcount();
    // this.checkaccess("CARDS");
    this.$vuetify.theme.transparent = true;
    // this.getcountNotification();
  },

  methods: {
    icon() {
      this.show = true;
    },
    async getcountNotification() {
      var inputData = {
        method_name: "ADMINCORP",
        page_no: 1,
        record_count: 0,
        page_size: null,
        app_code: "APORTAL",
        method_param: {
          action: "BADGES",
          module_type: this.$store.getters.get_display != 2 ? 2 : 3,
          corp_id:
            this.$store.getters.get_corpid == null
              ? 0
              : this.$store.getters.get_corpid,
          logged_user_id:
            this.$store.getters.get_display != 2
              ? this.$store.getters.get_userid
              : this.$store.getters.get_getRefDetails.user_id,
        },
      };

      var responseData = await apiCall(inputData);
      if (responseData.data.data != null) {
        for (let i = 0; i < responseData.data.data.length; i++) {
          switch (responseData.data.data[i].module_code) {
            case "CARDFUNDS":
              this.corpcount = responseData.data.data[i].count;
              this.$store.commit("SET_FundCount", this.corpcount);
              break;
            case "EXMGMT1":
              this.expensecount1 = responseData.data.data[i].count;
              this.$store.commit("SET_ExpenseCount1", this.expensecount1);
              break;
            case "EXMGMT2":
              this.expensecount2 = responseData.data.data[i].count;
              this.$store.commit("SET_ExpenseCount2", this.expensecount2);
              break;
            case "EXRVRY":
              this.expenserecover = responseData.data.data[i].count;
              this.$store.commit(
                "SET_ExpenseRecoverCount",
                this.expenserecover
              );
              break;
            case "CARDS":
              this.cardcount = responseData.data.data[i].count;
              this.$store.commit("SET_Requestcards", this.cardcount);
              break;
          }
        }
      }
    },
    // async checkaccess(data) {
    //   this.expandcheck = false;

    //   var inputData = {
    //     method_name: "ACCESS",
    //     page_no: 0,
    //     record_count: 0,
    //     page_size: 25,
    //     app_code: "CPORTAL",
    //     method_param: {
    //       action: "CHECK_ACCESS",
    //       user_id: this.$store.getters.get_userid,
    //       module_code: data,
    //       module_type: "2",
    //     },
    //   };
    //   var responseData = await apiCall(inputData);

    //   var checkaccessdata = responseData.data.data;

    //   if (
    //     checkaccessdata.is_approver == false &&
    //     checkaccessdata.is_checker == false &&
    //     checkaccessdata.is_maker == false &&
    //     checkaccessdata.is_viewer == false
    //   ) {
    //     this.$router.push("/accessdenied");
    //     this.expandcheck = true;
    //   }
    // },
    getcount() {
      this.$store.commit("SET_FundCount", this.fundcount);

      this.fundcount = this.$store.getters.get_FundCount;
    },

    pushToDept(value) {
      if (value == "Department") {
        this.$router.push("/Department");
      } else if (value == "Expense") {
        this.$router.push("/ExpenseMasters");
      } else if (value == "Category") {
        this.$router.push("/CategoryMasters");
      } else if (value == "Card") {
        this.$router.push("/CardMaster");
      }
      this.helpDeskStatus = false;
    },
    getBitcoins() {
      this.helpDeskStatus = true;
    },
    setfalsedialog(item) {
      this.item = item;
      // console.log(item);
      this.$store.commit("SET_dialogcheck", false);
    },
    // signOut() {
    //   this.$store.commit("SET_AUTH", false);
    //   this.$router.push("/");
    // },
    async signOut() {
      var inputData = {
        method_name: "CAUTH",
        page_no: null,
        record_count: 0,
        page_size: null,
        app_code: "CPORTAL",
        method_param: {
          action: "LOGOUT",
        },
      };
      var responseData = await apiCall(inputData);
      this.$store.commit("SET_AUTH", false);
      if (responseData.data.status == "00") {
        this.$router.push("/");
      } else {
        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "red",
        });
      }
    },
    profileDialog1open() {
      this.profileDialog1 = true;
    },
  },
};
</script>
<style scoped>
.border {
  background-color: #eeeeee;
  margin-left: 10px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
}
.v-list-item--active {
  background: linear-gradient(to bottom, #be9752, #dbb973 50%, #be9752);
  color: #202c37;
  margin-left: 1px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
}
.v-list--active {
  background: linear-gradient(
    90deg,
    rgba(165, 126, 60, 1) 0%,
    rgb(234, 201, 130) 50%,
    rgba(165, 126, 60, 1) 100%
  );
  color: white;
  margin-left: 1px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
}
</style>
